module.exports = __webpack_public_path__ + "img/not-plandata.78a64318.png";